const Toggle = () => {
    const toggleElements = document.querySelectorAll('[data-toggle]');

    toggleElements.forEach(element => {
        element.addEventListener('click', () => {
            const targetClass = element.getAttribute('data-toggle');
            const targetElement = document.querySelector(`.${targetClass}`);

            document.querySelectorAll('.actived').forEach(el => {
                if (el !== element && el !== targetElement) {
                    el.classList.remove('actived');
                }
            });

            element.classList.toggle('actived');
            if (targetElement) {
                targetElement.classList.toggle('actived');

                if (targetClass == 'menu-header') {
                    document.body.classList.toggle('overflow-hidden');
                }
            }
        });
    });
};

export default Toggle;
